<template>
  <div class="repository-collaborators-assets">
    <div class="repository-collaborators-assets__label">
      <UsersIcon />
      <button v-if="modelValue.length > 0" type="button" class="ui-link" @click="handleShareAssets">Share selected assets ({{modelValue.length}})</button>
      <span v-else>Share whole repository</span>
    </div>
    <button v-if="modelValue.length > 0" type="button" class="repository-collaborators-assets__link" @click="handleClearSelection">
      <XMarkIcon aria-hidden="true" class="size-3" />
      Clear selection
    </button>
    <div v-else class="ui-link" @click="handleShareAssets">Share assets</div>
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useModalsStore } from '@/store/modals'

import { UsersIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import CollaboratorsAssetsTree from './CollaboratorsAssetsTree.vue'

type Props = {
  repositoryId: string
}

const props = defineProps<Props>()

const modelValue = defineModel<string[]>({ required: true })

const modalsStore = useModalsStore()

const handleClearSelection = () => {
  modelValue.value = []
}

const handleShareAssets = () => {
  const modal = modalsStore.init('collaborators-assets-tree', markRaw(CollaboratorsAssetsTree))
  modal?.open(modalsStore.getZIndex(), {
    assetIds: modelValue.value,
    repositoryId: props.repositoryId,
    onDone: (value: string[]) => {
      modelValue.value = value
    },
  })
}
</script>

<style scoped>
.repository-collaborators-assets {
  @apply mb-5 -mt-1 px-2.5 py-1.5;
  @apply flex justify-between items-center;
  @apply bg-body-gray;
  @apply border border-common-border rounded-md;
  @apply text-xs;

  &__label {
    @apply flex items-center gap-2;

    svg {
      @apply size-4;
      @apply text-light-text;
    }
  }

  .ui-link {
    @apply cursor-pointer;
  }

  &__link {
    @apply flex items-center gap-1;
    @apply cursor-pointer;
    @apply text-light-text;
    @apply hover:underline decoration-light-text/40 underline-offset-2;
    @apply bg-transparent border-none p-0;
  }
}
</style>
